import { useState, useRef, useCallback, useEffect } from "react";

export function useVoiceDictation(setText) {
  const [active, setActive] = useState(false);
  const [interim, setInterim] = useState("");
  const recogRef = useRef(null);
  const timerRef = useRef(null);
  const finalRef = useRef("");
  const supported = typeof window !== "undefined" &&
    ("SpeechRecognition" in window || "webkitSpeechRecognition" in window);

  const stop = useCallback(() => {
    clearTimeout(timerRef.current);
    recogRef.current?.abort();
    recogRef.current = null;
    setActive(false); setInterim("");
    if (finalRef.current.trim()) setText(p => p ? p + " " + finalRef.current.trim() : finalRef.current.trim());
    finalRef.current = "";
  }, [setText]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
      recogRef.current?.abort();
      recogRef.current = null;
    };
  }, []);

  const toggle = useCallback(() => {
    if (active) { stop(); return; }
    if (!supported) return;
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const r = new SR(); r.continuous = true; r.interimResults = true; r.lang = "en-US";
    finalRef.current = "";
    r.onresult = e => {
      let fin = "", int = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) fin += e.results[i][0].transcript + " ";
        else int += e.results[i][0].transcript;
      }
      if (fin) finalRef.current += fin;
      setInterim(int);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => stop(), 2000);
    };
    r.onend = () => { setActive(false); setInterim(""); };
    r.start(); recogRef.current = r; setActive(true);
  }, [active, supported, stop]);

  return { active, interim, toggle, supported };
}
